import { OverlayModule } from '@angular/cdk/overlay';
import { NgModule } from '@angular/core';
import { Route, RouterModule } from '@angular/router';
import { DevelopmentGuard } from '@libs/shared/common';
import {
  CHECKOUT_CART_ROUTE_PATH,
  CHECKOUT_CONFIRMATION_ROUTE_PATH,
  CHECKOUT_OVERVIEW_ROUTE_PATH,
  NAVBAR_ASSORTMENT_ROUTE,
  NAVBAR_OFFERS_ROUTE_NAME,
  NAVBAR_ORDER_MANAGER_ROUTE_NAME,
  ORDER_HISTORY_ORDER_ROUTE_PATH,
  ORDER_HISTORY_ORDERS_ROUTE_PATH,
  ORDERS_QUICK_ORDER_ROUTE_PATH,
  ORDERS_RECENT_PRODUCTS_ROUTE_PATH,
  ORDERS_SHOPPING_LIST_DETAIL_ROUTE_PATH,
  ORDERS_SHOPPING_LISTS_ROUTE_PATH,
  SCANNER_ROUTE_NAME,
  USER_CUSTOMER_SWITCH_ROUTE_PATH,
  USER_HOME_ROUTE_PATH,
  USER_LOGOUT_ROUTE_PATH,
} from '@libs/shared/models';
import {
  FeatureFlagDebuggerComponent,
  LiveUpdateDebuggerComponent,
  LoginDebuggerComponent,
  LogoutComponent,
  ScannerComponent, TrackingDebuggerComponent,
} from '@libs/templates/cep';
import {
  CheckoutComponent,
  CheckoutSuccessComponent,
  CustomerContextSwitchComponent,
  LastOrderedProductsTableListComponent,
  MobileNavigationRouteComponent,
  OffersComponent,
  OrderManagerComponent, QuickOrderComponent,
  ShoppingCartComponent,
  ShoppingListComponent,
  ShoppingListsComponent,
} from '@libs/shop/components';
import { OrderHistoryOverviewComponent, OrderHistoryRecordComponent } from '@libs/services/components';
import { ContentPageRouteComponent } from '../content';

export const userRoutes: Route[] = [
  {
    path: '',
    redirectTo: USER_HOME_ROUTE_PATH,
    pathMatch: 'full',
  },
  {
    path: USER_HOME_ROUTE_PATH,
    component: ContentPageRouteComponent,
  },
  {
    path: USER_CUSTOMER_SWITCH_ROUTE_PATH,
    component: CustomerContextSwitchComponent,
  },
  {
    path: USER_LOGOUT_ROUTE_PATH,
    component: LogoutComponent,
  },
];

export const checkoutRoutes: Route[] = [
  {
    path: CHECKOUT_CART_ROUTE_PATH,
    component: ShoppingCartComponent,
  },
  {
    path: CHECKOUT_OVERVIEW_ROUTE_PATH,
    component: CheckoutComponent,
  },
  {
    path: CHECKOUT_CONFIRMATION_ROUTE_PATH,
    component: CheckoutSuccessComponent,
  },
  {
    path: CHECKOUT_CONFIRMATION_ROUTE_PATH + '/:deliveryDate',
    component: CheckoutSuccessComponent,
  },
];

export const orderHistoryRoutes: Route[] = [
  {
    path: ORDER_HISTORY_ORDERS_ROUTE_PATH,
    component: OrderHistoryOverviewComponent,
  },
  {
    path: ORDER_HISTORY_ORDER_ROUTE_PATH,
    component: OrderHistoryRecordComponent,
  },
  {
    path: ORDERS_RECENT_PRODUCTS_ROUTE_PATH,
    component: LastOrderedProductsTableListComponent,
  },
  {
    path: ORDERS_SHOPPING_LISTS_ROUTE_PATH,
    component: ShoppingListsComponent,
  },
  {
    path: ORDERS_SHOPPING_LIST_DETAIL_ROUTE_PATH,
    component: ShoppingListComponent,
  },
  {
    path: ORDERS_QUICK_ORDER_ROUTE_PATH,
    component: QuickOrderComponent,
  },
];

export const navbarOverlayRoutes: Route[] = [
  {
    path: NAVBAR_ASSORTMENT_ROUTE,
    component: MobileNavigationRouteComponent,
  },
  {
    path: NAVBAR_ASSORTMENT_ROUTE + '/:currentCategoryId',
    component: MobileNavigationRouteComponent,
  },
  {
    path: NAVBAR_OFFERS_ROUTE_NAME,
    component: OffersComponent,
  },
  {
    path: NAVBAR_OFFERS_ROUTE_NAME + '/:currentCategoryId',
    component: OffersComponent,
  },
  {
    path: NAVBAR_ORDER_MANAGER_ROUTE_NAME,
    component: OrderManagerComponent,
  },
];

export const scannerRoutes: Route[] = [
  {
    path: SCANNER_ROUTE_NAME + '/:handlerKey/:relatedResourceId',
    component: ScannerComponent,
  },
];

export const debuggerRoutes: Route[] = [
  {
    path: 'login-debugger',
    canActivate: [DevelopmentGuard],
    component: LoginDebuggerComponent,
  },
  {
    path: 'live-update-debugger',
    canActivate: [DevelopmentGuard],
    component: LiveUpdateDebuggerComponent,
  },
  {
    path: 'feature-flag-debugger',
    canActivate: [DevelopmentGuard],
    component: FeatureFlagDebuggerComponent,
  },
  {
    path: 'tracking-debugger',
    canActivate: [DevelopmentGuard],
    component: TrackingDebuggerComponent,
  },
];

export const cepRoutes: Route[] = [
  ...userRoutes,
  ...checkoutRoutes,
  ...orderHistoryRoutes,
  ...navbarOverlayRoutes,
  ...scannerRoutes,
  ...debuggerRoutes,
];

@NgModule({
  imports: [
    OverlayModule,
    RouterModule.forChild(cepRoutes),
  ],
  exports: [],
})
export class CepRouteModule {
}
